import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { getAdjustedDate } from "../CommonFunctions";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import dayjs from "dayjs";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
import { APIConstants } from "../../../Common/APIConstants";
import { Card, Select } from "antd";

const LineTable = (props) => {
  const theme = props.theme;
  console.log(theme) 
  const correctDate = new Date(getAdjustedDate());
  const [data, setData] = useState([]);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [loading, setLoading] = useState(true);
  const [groupDetails,setGroupDetails]=useState([])
  const [group,setGroup]=useState(9)
  const [columns, setColumns] = useState([]);
  const [toDate, setToDate] = useState(
    dayjs(correctDate).hour(6).minute(0).second(0)
  );
  // const [fromDate, setFromDate] = useState(
  //   dayjs(correctDate).subtract(30, "days").hour(6).minute(0).second(0)
  // );
    const [fromDate, setFromDate] = useState(() =>
      dayjs().startOf("month").hour(6).minute(0).second(0)
    );
  // const [fromDate, setFromDate] = useState(() =>
  //   dayjs().startOf("month").hour(6).minute(0).second(0)
  // );

  const formatDateForURL = (dateString) => {
    const date = new Date(dateString);
    date.setMilliseconds(0); // Remove milliseconds

    let isoString = date.toISOString().split(".")[0]; // Remove milliseconds part
    return encodeURIComponent(isoString.replace("T", " "));
  };
  const getReposnse = async () => {
    // setLoading(true)
    const currentDate = new Date();

    // const { from, to } = calculateDateRangeFromDate(currentDate, 1, 1);
    console.log(fromDate);

    const inputData = {
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    };
    console.log("getReposnse");
    console.log(
      formatDateForURL(inputData.ToDate),
      formatDateForURL(inputData.FromDate)
    );
    // console.log(encodeURIComponent(inputData.ToDate), encodeURIComponent(inputData.FromDate));
    console.log(inputData.ToDate, inputData.FromDate);

    const url = `${APIConstants.LINE_SEC_CONSUMPTION}?GroupID=${group}&FromDate=${formatDateForURL(inputData.FromDate)}&ToDate=${formatDateForURL(inputData.ToDate)}`;
    console.log(url);
    try {
      const res = await makeRequest({
        type: APIConstants.GET,
        // url: `${APIConstants.LUCAS_SF6VCB_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
        url: url,
      });
      console.log(res);
      if (res && res.length) {
        const transformedData = res.reduce(
          (acc, { fromDate, groupName, groupConsumptionValue }) => {
            const formattedGroupName =
              groupName === "MAIN EB INCOMER"
                ? "eb"
                : groupName === "TotalConsumption"
                  ? "Total"
                  : groupName;

            // Remove "T" and time from fromDate
            const formattedDate = fromDate.split("T")[0];

            // Find an existing entry for the same fromDate
            let entry = acc.find((item) => item.fromDate === formattedDate);
            if (!entry) {
              entry = { fromDate: formattedDate };
              acc.push(entry);
            }

            // Assign groupConsumptionValue under the formatted group name
            entry[formattedGroupName] = groupConsumptionValue;

            return acc;
          },
          []
        );

        console.log(transformedData);
        const reverse = transformedData.reverse()
              console.log(reverse)
              // console.log(transformedData.reverse());
              setRowData(reverse);
      } else {
        setRowData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  console.log(data);

  useEffect(() => {
    getReposnse();
  }, [group]);

  const [rowData, setRowData] = useState([]);

  console.log(rowData);
 
  useEffect(() => {
    if (rowData&&rowData.length > 0) {
      // Extract the dynamic column name from the first data object
      const dynamicColumnName = Object.keys(rowData[0]).find(
        (key) => key !== "fromDate" && key !== "SEC" && key !== "Production" && key !== "AirConsumption"
      );

 // const columnDefs = [
  //   {
  //     headerName: "Date",
  //     field: "toDate",
  //     sortable: true,
  //     filter: true,
  //     width: 140,
  //   },{
  //     headerName: "EB Units",
  //     field: "GF",
  //     sortable: true,
  //     filter: true,
  //     width: 120,
  //   },
  //   {
  //     headerName: "SEC",
  //     field: "SEC",
  //     sortable: true,
  //     filter: true,
  //     width: 120,
  //   },
  //   {
  //     headerName: "AirConsumption",
  //     field: "AirConsumption",
  //     sortable: true,
  //     filter: true,
  //     width: 180,
  //   },
  //   {
  //     headerName: "Production",
  //     field: "Production",
  //     sortable: true,
  //     filter: true,
  //     width: 160,
  //   },
  // ];
  
  

      // Define table columns
      const columnDefs = [
        {
          headerName: "Date",
          field: "fromDate",
          key: "fromDate",
          sortable: (a, b) => new Date(a.fromDate) - new Date(b.fromDate),
          minWidth: 140,
        },
        {
          headerName: "Energy Consumption",
          field: dynamicColumnName,
          key: "GF",
          sortable: (a, b) => a[dynamicColumnName] - b[dynamicColumnName],
          minWidth: 170,
        },
        {
          headerName: "SEC",
          field: "SEC",
          key: "SEC",
          sortable: (a, b) => a.SEC - b.SEC,
          minWidth: 80,
        },
        {
          headerName: "Air Consumption",
          field: "AirConsumption",
          key: "AirConsumption",
          sortable: (a, b) => a.AirConsumption - b.AirConsumption,
          minWidth: 150,
        },
        {
          headerName: "Production",
          field: "Production",
          key: "Production",
          sortable: (a, b) => a.Production - b.Production,
          minWidth: 130,
        },
      ];

      setColumns(columnDefs);
    }
  }, [rowData]);
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setGroup(value)
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_LINE_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if(res && res.length){
        setGroupDetails(res)
      }
    });
  }, [])
  console.log(groupDetails)
  console.log(columns)
  console.log(rowData)
  
  return (
    <Card
      className={` ${
        theme === "dark" ? "bg-transparent" : "bg-white"
      } ag-theme-alpine w-full h-96 overflow-hidden p-0 shadow-xl  rounded-lg`}
    >
      <div className="flex justify-between items-center">
        <h2 className={`${
        theme === "dark" ? "text-white" : "text-black"
      }  text-lg font-semibold text-left pl-1 `}>Line SEC Data</h2>
        <Select
          //   defaultValue="lucy"
          style={{
            width: 150,
          }}
          className="mb-2 border rounded-lg"
          onChange={handleChange}
          placeholder="Filter by Line"
          defaultValue={9}
        > 
          {groupDetails.map((dept) => (
        <Option key={dept.groupID} value={dept.groupID}>
          {dept.department}
        </Option>
      ))}
        </Select>
      </div>

      {/* <div className=" h-72 rounded-lg p-0 ">
        <AgGridReact
          rowData={rowData}
          columnDefs={columns}
          pagination={true}
          paginationPageSize={10}
        />
      </div> */}
       <div className={`${theme==='dark' ? "ag-theme-quartz-dark" : "ag-theme-alpine custom-grid-light"} h-72`} >
             <AgGridReact 
               rowData={rowData}
               columnDefs={columns?.length > 1 ? columns : []}
               pagination={true}
               domLayout="normal"
               defaultColDef={{
                resizable: true, // Allow column resizing
                flex: 1, // Distribute columns evenly
                // minWidth: 160, // Ensure minimum column width
              }}
               rowHeight={50}
               suppressHorizontalScroll={false}
               overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`} 
             />
           </div>
    </Card>
  );
};

export default LineTable;
